<template>
    <DCard
        :padding="true"
    >
        <Form
            :available-widgets="availableWidgets"
            :selected-widgets="selectedWidgets"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Settings/DashboardSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    availableWidgets: {
        type: Array,
        default () {
            return []
        }
    },
    selectedWidgets: {
        type: Array,
        default () {
            return []
        }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

function submitData (form) {
    form.post(route('settings.dashboard-settings.store'))
}
</script>
